import { createApp, nextTick } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router/index.js'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import Axios from 'axios';

import App from './App.vue'


const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(router)
app.config.globalProperties.$axios = Axios
app.use(ElementPlus)
app.mount('#app')

// 通知预渲染脚本：异步路由已挂载完毕，可以抓取 HTML
// 详见 scripts/prerender.js
router.isReady().then(() => {
    nextTick(() => {
        document.dispatchEvent(new Event('render-event'))
    })
})
